<template>
    <el-dialog
        title="订单信息"
        :visible.sync="orderMoneyOkDialog"
        width="50%"
        class="dialogShowPayQian"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-loading="loadingStatus"
        >
            <el-form class="contentBoxForm" ref="addForm" label-width="120px" :model="form" :rules="rules">
                <el-row>
                    <el-form-item label="项目名称:" class="textL"><b style="font-size: 16px;">{{paperInfo.paperNameRemark?paperInfo.paperNameRemark:paperInfo.paperName ||''}}</b></el-form-item>
                    <el-form-item label="支付金额:" class="textL"><b style="color: #FF7800;"><span style="font-size: 24px;">{{paperInfo.examSignOrderPrice||''}}</span> 元</b></el-form-item>
                    <el-form-item label="支付状态:" class="textL"><b style="font-size: 16px;">{{paperInfo.orderStatusTxt?paperInfo.orderStatusTxt[paperInfo.examSignOrderStatus]:''}}</b></el-form-item>
                    <el-form-item label="支付时间:" class="textL" v-if="paperInfo.examSignOrderStatus==21"><b style="font-size: 16px;">{{paperInfo.payDateVal||''}}</b></el-form-item>
                    <el-form-item label="发票邮箱:" class="textL" v-if="paperInfo.examSignOrderStatus==21"><b style="font-size: 16px;">{{paperInfo.examSignOrderEmail||''}}</b></el-form-item>
                    <el-form-item label="订单编号:" class="textL" v-if="paperInfo.examSignOrderStatus==21"><b style="font-size: 16px;">{{paperInfo.examSignOrderNo||''}}</b></el-form-item>
                    <el-form-item label="" class="textL" v-if="paperInfo.examSignOrderStatus==21" label-width="50px"><b style="font-size: 18px;color:red">注: 发票最晚于 4月30日 发送至邮箱，请注意查收！</b></el-form-item>
                    <el-form-item label="接收发票邮箱:" prop="mailbox" required v-if="paperInfo.examSignOrderStatus==20">
                        <el-input type="text" v-model="form.mailbox" clearable placeholder="请输入接收发票的邮箱地址" style="float: left;width:80%"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="goStartPay" class="comePayBtu" v-if="paperInfo.examSignOrderStatus==20">&nbsp;</el-button>
            <el-button @click="offDialog">返回</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default{
    data(){
        return {
            loadingStatus:false,
            orderMoneyOkDialog:false,
            form:{
                mailbox:'',
            },
            paperInfo:'',
            rules: {
                mailbox:[{ required: true, message: "请输入邮箱", trigger: "blur" }],
            }
        }
    },
    methods:{
        open(item){
            this.paperInfo = item
            // console.log(JSON.parse(JSON.stringify(item)))
            if(this.paperInfo.examSignOrderEmail)
            this.form.mailbox = this.paperInfo.examSignOrderEmail
            this.orderMoneyOkDialog = true
        },
        handleClose(done){
            this.offDialog()
            done();
        },
        offDialog(){
            this.form.mailbox = ''
            this.$refs['addForm'].resetFields()
            this.orderMoneyOkDialog = false
        },
        goStartPay(){
            let that = this
            that.$refs['addForm'].validate((valid) => {
                if (valid) {
                    if(!that.isValidEmail(that.form.mailbox)){
                        that.$message.error('邮箱格式错误')
                        return
                    }
                    that.goPay()
                }
            })
        },
        goPay(){
            let that = this
            let param = {
                orderId:that.paperInfo.examSignOrderId,
                fromSource:'web',
                payWay:'SL', //支付宝=ALIPAY ,微信=WX ,YB=易宝,YL=银联 SL=商联
                additionalInfo:'',//项目来源及其他附加信息
                email:that.form.mailbox,
                uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
            }
            that.loadingStatus = true
            that.$axios.post('/examSignOrder/payInfo',param,function(res){
                that.loadingStatus = false
                // console.log(param,res)
                if(res.data&&res.data.code == 0){
                    if(res.data.data.payWay){
                        if(!res.data.data.jsonVal){
                            that.$message.error('支付异常,请重试!')
                            return
                        }
                        const payJson = JSON.parse(res.data.data.jsonVal)
                        if(payJson.status=='05'){
                            if(!payJson.code_url){
                                that.$message.error('支付异常,请重试!')
                                return
                            }
                            // const link = document.createElement('a');
                            // link.href = payJson.code_url;
                            // link.target = '_blank';
                            // document.body.appendChild(link);
                            // link.click();
                            // document.body.removeChild(link);//a标签另打开减小浏览器弹窗阻拦概率
                            // window.location.href = payJson.code_url
                            that.$router.push({
                                path:'/slToWechatQR',
                                query:{
                                    payNum:res.data.data.payNum,
                                    url:payJson.code_url,
                                    price:that.paperInfo.examSignOrderPrice
                                }
                            })
                        }else if(payJson.status=='04'){
                            that.$message.error('支付失败，支付码正在被使用!')
                        }else{
                            that.$message.error('支付异常,请重试!')
                        }
                    }else{
                        that.$message.error(res.data.msg)
                    }
                }else{
                    that.$message.error(res.data.msg)
                }
            })
        },
        clickCopy() { 
            var clipboard = new this.Clipboard('.copyMail');  
            clipboard.on('success', e => {  
                this.$notify({
                    title: '复制成功',
                    type: 'success'
                });
                // 释放内存  
                clipboard.destroy()  
            })  
            clipboard.on('error', e => {  
                // 不支持复制
                this.$notify({
                    title: '该浏览器不支持自动复制',
                    type: 'success'
                }); 
                // 释放内存  
                clipboard.destroy()  
            })  
        },
        isValidEmail(email) {
            // 邮箱正则表达式
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
    }
}
</script>
<style scoped lang="less">
    .comePayBtu{
        width: 130px;
        height: 40px;
        background: url(https://pay.weixin.qq.com/wiki/doc/wxfacepay/wechat-pay@2x.png);
        background-size: 89%;
        background-repeat: no-repeat;
        background-position: center;
    }
</style>
<style>
    .dialogShowPayQian .el-dialog{
        width: 700px !important;
    }
    .dialogShowPayQian .el-dialog__body{
        padding: 20px;
    }
    .contentBoxForm .el-form-item{
        margin-bottom: 10px !important;
    }
    .comePayBtu.el-button--info:active,
    .comePayBtu.el-button--info:focus,
    .comePayBtu.el-button--info:hover{
        border-color: #c6e2ff !important;
        color: #fff !important;
        background: url(https://pay.weixin.qq.com/wiki/doc/wxfacepay/wechat-pay@2x.png);
        background-size: 89%;
        background-repeat: no-repeat;
        background-position: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/exam2/toPayDialog.vue